export const EXPERIENCES = [
  ["Dinner Date", "An elegant evening out in Athens or a selected destination."],
  ["VIP Companion", "A polished companion for premium social occasions."],
  ["Event Appearance", "A discreet presence for private events and appearances."],
  ["Private Session", "A private, mutually agreed arrangement."],
  ["Travel Companion", "Selected travel dates and extended arrangements."],
  ["Custom Arrangement", "A tailored experience based on your request."],
];
export const DURATIONS = ["1 hour", "2 hours", "3 hours", "Dinner date (4 hours)", "Overnight", "24 hours", "Multi-day / travel"];
export const BOOKING_STATUSES = ["new", "contacted", "screening", "confirmed", "deposit_pending", "completed", "cancelled", "blocked"];
export const localDate = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
};
export function validateEnquiry(values) {
  const errors = {};
  for (const key of ["name", "email", "phone", "preferred_date", "preferred_time", "duration", "service_type", "location"]) {
    if (!String(values[key] || "").trim()) errors[key] = "This field is required.";
  }
  if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) errors.email = "Enter a valid email address.";
  if (values.preferred_date && values.preferred_date < localDate()) errors.preferred_date = "Choose today or a future date.";
  if (!values.consent_given) errors.consent_given = "Please confirm that you are 18+ and consent to this enquiry.";
  return errors;
}
export function bookingFields(record) {
  return {
    ...record,
    name: record.name || record.client_name || "",
    email: record.email || record.client_email || "",
    phone: record.phone || record.client_phone || "",
    preferred_date: record.preferred_date || record.booking_date || "",
    preferred_time: record.preferred_time || record.booking_time || "",
    duration: record.duration || `${record.duration_hours || 2} hours`,
    notes: record.notes || record.service_description || "",
  };
}
export function bookingsCsv(records) {
  const columns = ["name", "email", "phone", "preferred_date", "preferred_time", "service_type", "duration", "location", "budget_range", "status", "source", "notes", "consent_given", "created_at"];
  const cell = (value) => {
    let text = String(value ?? "");
    if (/^[\s]*[=+\-@\t\r]/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
  };
  return [columns.map(cell).join(","), ...records.map((record) => {
    const normalized = bookingFields(record);
    return columns.map((key) => cell(normalized[key])).join(",");
  })].join("\r\n");
}
